"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Dropdown = /*#__PURE__*/function () {
  function Dropdown(container) {
    var _this = this;

    _classCallCheck(this, Dropdown);

    this.container = container;
    this.list = this.container.querySelector('ul');
    this.button = this.container.querySelector('button');
    this.select = this.container.querySelector('select');
    this.name = this.select.name;
    this.event = document.createEvent("HTMLEvents");
    this.event.initEvent("change", false, true);
    this.values = [];

    _toConsumableArray(this.select.querySelectorAll('option')).map(function (el) {
      if (el.value != 0) {
        _this.values.push({
          el: el,
          value: el.value,
          label: el.textContent
        });
      }
    });

    this.init();
  }

  _createClass(Dropdown, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.generateList();
      setTimeout(function () {
        if (_this2.select.value != 0) {
          _this2.list.querySelector('[data-value="' + _this2.select.value + '"').classList.add('is-active');
        }
      }, 0);
      this.container.addEventListener('click', function (event) {
        event.stopPropagation();

        var dropdowns = _toConsumableArray(document.getElementsByClassName('js-dropdown'));

        dropdowns = dropdowns.filter(function (el) {
          return el != _this2.container;
        });
        dropdowns.forEach(function (d) {
          d.classList.remove('is-open');
        });
      });
      this.select.addEventListener('focus', function (event) {
        _this2.button.click();

        _this2.list.firstChild.focus();
      });
      this.list.addEventListener('keyup', function (event) {
        if (event.keyCode == 38) {
          var previous = event.srcElement.previousSibling;

          if (previous) {
            previous.focus();
          }
        }

        if (event.keyCode == 40) {
          var next = event.srcElement.nextSibling;

          if (next) {
            next.focus();
          }
        }

        if (event.keyCode == 13) {
          event.srcElement.click();
        }
      });
    }
  }, {
    key: "generateList",
    value: function generateList() {
      var _this3 = this;

      if (!this.button) {
        var button = document.createElement("BUTTON");
        button.addEventListener('click', function (event) {
          _this3.toggle();
        });
        this.container.appendChild(button);
        this.button = this.container.querySelector('button');
      }

      if (!this.list) {
        var list = document.createElement("UL");
        this.container.appendChild(list);
        this.list = this.container.querySelector('ul');
      }

      this.values.forEach(function (val) {
        var item = document.createElement("LI");
        item.dataset.value = val.value;
        item.textContent = val.label;
        item.tabIndex = 0;

        _this3.bindClick(item);

        _this3.list.appendChild(item);
      });
    }
  }, {
    key: "bindClick",
    value: function bindClick(element) {
      var _this4 = this;

      element.addEventListener('click', function (event) {
        var value = event.srcElement.dataset.value;

        var active = _this4.list.querySelector('.is-active');

        _this4.select.value = value;

        _this4.select.dispatchEvent(_this4.event);

        if (active) {
          active.classList.remove('is-active');
        }

        event.srcElement.classList.add('is-active');

        _this4.toggle();
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.container.classList.toggle('is-open');
    }
  }]);

  return Dropdown;
}();

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName('js-dropdown')) {
    var dropdowns = _toConsumableArray(document.getElementsByClassName('js-dropdown'));

    dropdowns.forEach(function (d) {
      new Dropdown(d);
    });
    document.addEventListener('click', function () {
      dropdowns.forEach(function (d) {
        d.classList.remove('is-open');
      });
    });
  }
});